import * as tslib_1 from "tslib";
import SearchInput from './SearchInput';
import { setIsUsing3S } from '../actions/internalActions';
import { exitSearch, searchBoxBlurred, startSearch } from '../actions/publicActions';
import { getStore } from '../store/store';
import getSearchBoxMaxWidth from '../utils/getSearchBoxMaxWidth';
import { observer } from 'mobx-react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import * as React from 'react';
import { lazyIsSearchBoxEmpty, lazyRemoveSuggestionPillFromSearchBox, SearchBoxPillWell, SuggestionsContextMenu, lazySetIsFocusInSearchInput, } from 'owa-search';
var classNames = require('classnames/bind');
var styles = require('./SearchBox.scss');
var SearchBox = /** @class */ (function (_super) {
    tslib_1.__extends(SearchBox, _super);
    function SearchBox(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Sets focus on SearchInput component.
         */
        _this.focusSearchInput = function () {
            _this.searchInput.setFocus();
        };
        _this.isSuggestionsContextMenuVisible = function () {
            return getStore().isFocusInSearchInput && !!getStore().searchSessionGuid;
        };
        /**
         * Click handler to set focus on the SearchInput component.
         */
        _this.onSearchBoxClick = function (evt) {
            evt.stopPropagation();
            _this.focusSearchInput();
        };
        /**
         * Dispatches the startSearch action when the user clicks on the search button,
         * if the search box is not empty. Otherwise, set focus on SearchInput.
         */
        _this.onSearchButtonClick = function (evt) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var isSearchBoxEmpty;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        evt.stopPropagation();
                        return [4 /*yield*/, lazyIsSearchBoxEmpty.import()];
                    case 1:
                        isSearchBoxEmpty = _a.sent();
                        if (!isSearchBoxEmpty()) {
                            startSearch('SearchButton', true /* explicitSearch */);
                        }
                        else {
                            this.focusSearchInput();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Dispatches the exitSearch action to notify consumer that user wants to exit
         * the search experience.
         */
        _this.onExit = function (actionSource) {
            exitSearch(actionSource);
        };
        /**
         * Focus handler for when an element within the SearchBox component loses focus.
         * We check if the clickSource property matches the value that all SearchBox
         * elements should have, and if they don't match we'll dispatch an action
         * notifying consumer that search box has lost focus.
         */
        _this.onSearchBoxBlur = function (evt) {
            var relatedTargetElement = evt.relatedTarget;
            /**
             * A way of determining if element that caused JavaScript event is from
             * within search box.
             */
            var isTargetElementWithinSearchBox = _this.searchBoxContainer.contains(relatedTargetElement);
            /**
             * Truly "blur" only if event is from outside of search box.
             */
            if (!isTargetElementWithinSearchBox) {
                lazySetIsFocusInSearchInput.importAndExecute(false /* isFocusInSearchInput */);
                searchBoxBlurred();
            }
        };
        /**
         * Click handler when user chooses to click the "X" on a pill to remove it
         * from the search box.
         */
        _this.onRemovePillClick = function (suggestionPillId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var removeSuggestionPillFromSearchBox;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Set focus in input.
                        this.focusSearchInput();
                        return [4 /*yield*/, lazyRemoveSuggestionPillFromSearchBox.import()];
                    case 1:
                        removeSuggestionPillFromSearchBox = _a.sent();
                        removeSuggestionPillFromSearchBox(suggestionPillId);
                        return [2 /*return*/];
                }
            });
        }); };
        var _a = props.isUsing3S, isUsing3S = _a === void 0 ? true : _a;
        /**
         * Before component loads, set value in the store if consumer is using
         * 3S or not, so our instrumentation is correct.
         */
        setIsUsing3S(isUsing3S);
        return _this;
    }
    SearchBox.prototype.render = function () {
        var _this = this;
        var searchStore = getStore();
        // If searchSessionGuid has a value, user is in a search session.
        var isSearchBoxExpanded = !!searchStore.searchSessionGuid;
        var searchBoxContainerStyle = {
            maxWidth: getSearchBoxMaxWidth(isSearchBoxExpanded, this.props.customCollapsedMaxWidth) + "px",
        };
        var searchBoxContainerClassNames = classNames(styles.searchBoxContainer, isSearchBoxExpanded && styles.searchBoxContainerInSearch);
        return (React.createElement("div", { className: searchBoxContainerClassNames, ref: function (ref) { return (_this.searchBoxContainer = ref); }, style: searchBoxContainerStyle },
            React.createElement("div", { className: styles.searchBox, ref: function (ref) { return (_this.searchBox = ref); } },
                this.isSuggestionsContextMenuVisible() && (React.createElement(SuggestionsContextMenu, { onBlur: this.onSearchBoxBlur, targetElement: this.searchBox })),
                isSearchBoxExpanded ? (React.createElement(IconButton, { className: styles.backButton, iconProps: { iconName: "ChevronLeft" /* ChevronLeft */ }, onClick: function () {
                        _this.onExit('SearchBoxBackArrow');
                    } })) : (React.createElement("div", { "aria-hidden": true, className: styles.searchIcon, onBlur: this.onSearchBoxBlur, onClick: this.onSearchBoxClick },
                    React.createElement(Icon, { iconName: "Search" /* Search */ }))),
                React.createElement("div", { className: styles.searchQueryContainer, onClick: this.onSearchBoxClick },
                    searchStore.suggestionPillIds.length > 0 && (React.createElement(SearchBoxPillWell, { onRemovePill: this.onRemovePillClick })),
                    React.createElement(SearchInput, { onBlur: this.onSearchBoxBlur, ref: function (ref) { return (_this.searchInput = ref); } })),
                isSearchBoxExpanded &&
                    this.props.renderRefiners &&
                    this.props.renderRefiners()),
            isSearchBoxExpanded && (React.createElement(IconButton, { className: styles.searchButton, iconProps: {
                    iconName: "Search" /* Search */,
                }, onBlur: this.onSearchBoxBlur, onClick: this.onSearchButtonClick }))));
    };
    SearchBox = tslib_1.__decorate([
        observer
    ], SearchBox);
    return SearchBox;
}(React.Component));
export default SearchBox;
//# sourceMappingURL=SearchBox.js.map